import type { PropsWithChildren } from 'react';
import { ErrorPageContent } from '@/app/components/ErrorPageContent';
import PageLayout from '@/app/components/PageLayout';
import BulkOrderBackground from '@/app/components/ui/BulkOrderBackground';
import { ErrorPageShell } from '../ErrorPageShell';

type ErrorPageProps = PropsWithChildren<{
  readonly name: string;
  readonly description: string;
  readonly headline: string;
  readonly title: string;
  readonly lang?: string;
  readonly navigation?: React.ReactNode;
}>;

export default function ErrorPage({
  name,
  children,
  lang = 'en',
  navigation,
  ...props
}: ErrorPageProps) {
  return (
    <ErrorPageShell lang={lang} navigation={navigation}>
      <PageLayout
        name={name}
        className="relative flex min-h-[calc(100dvh_-_60px)] w-full items-center justify-center desktop:min-h-[calc(100dvh_-_80px)]"
      >
        <ErrorPageContent {...props}>{children}</ErrorPageContent>
        <BulkOrderBackground />
      </PageLayout>
    </ErrorPageShell>
  );
}
